// CLARTEXT SPRACHE V1 – Phase 7E (P0.1): Polnische UI-Chrome-Texte der
// Mitarbeiter-App. Schlüssel-IDENTISCH zu de.js (Quelle der Wahrheit) — KEINE
// neuen Keys, KEINE Strukturänderung, nur Übersetzung bestehender Schlüssel.
// Weltinhalte (Welt-Titel, Fragen, Antwortoptionen, GBU-/BA-Texte) sind Daten
// und bleiben hiervon unberührt (Backend-Resolver).
const pl = {
  // Gemeinsame
  "common.loading": "Ładowanie…",

  // PIN-Login (/monteur/login)
  "login.eyebrow": "Logowanie",
  "login.title": "Twój PIN",
  "login.subtitle": "Kod firmy + 4-cyfrowy PIN od Twojego szefa.",
  "login.companyCodeLabel": "Kod firmy",
  "login.companyCodePlaceholder": "np. LUMPE",
  "login.submitting": "Logowanie w toku…",
  "login.backAria": "Powrót do logowania",
  "login.errorNoCode": "Najpierw wprowadź kod firmy.",
  "login.errorUnknown": "Nieznana firma lub PIN.",

  // Aufgabenliste (/monteur)
  "tasks.companyFallback": "Twój zakład",
  "tasks.portalSubtitle": "Portal instruktaży",
  "tasks.loggedInAs": "Zalogowano jako",
  "tasks.heading": "Twoje zadania",
  "tasks.openCount": "Otwarte: {count}",
  "tasks.emptyToday": "Dziś brak otwartych zadań.",
  "tasks.newBanner": "Masz {count} nowe szkolenie(a) od Twojej ostatniej wizyty.",
  "tasks.newBadge": "Nowe",
  "tasks.newBannerDismissAria": "Zamknij powiadomienie",
  "tasks.backAria": "Powrót do przeglądu",
  "home.tasksTitle": "Szkolenia",
  "home.searchTitle": "Kompendium",
  "home.searchSubtitle": "Szybko sprawdź informacje BHP",
  "home.hspTitle": "Plan ochrony skóry",
  "home.hspSubtitle": "Ochrona skóry i dobór rękawic w skrócie",
  "home.driverTitle": "Kontrola prawa jazdy",
  "home.driverOpen": "Prześlij prawo jazdy",
  "home.driverSubmitted": "Oczekuje na weryfikację firmy",
  "home.driverUpToDate": "Aktualnie ważne",
  "home.settingsTitle": "Ustawienia",
  "home.settingsSubtitle": "Zarządzaj e-mailem i językiem",
  "home.comingSoon": "Wkrótce dostępne",
  "home.newBubbleAria": "{count} nowe szkolenia",
  "settings.profileTitle": "Profil",
  "settings.profileHint": "Imię i firma są zarządzane przez firmę.",
  "settings.emailTitle": "E-mail do powiadomień",
  "settings.emailPurpose": "Używany wyłącznie do informowania o nowych szkoleniach.",
  "settings.emailPlaceholder": "imie@przyklad.pl",
  "settings.emailSave": "Zapisz",
  "settings.emailSaved": "Zapisano",
  "settings.emailInvalid": "Podaj prawidłowy adres e-mail.",
  "settings.emailRemoveHint": "Wyczyść pole i zapisz, aby się wypisać.",
  "settings.saveError": "Zapis nie powiódł się. Spróbuj ponownie.",
  "settings.privacyLink": "Polityka prywatności",
  "settings.consentLabel": "Chcę otrzymywać powiadomienia e-mail o nowych szkoleniach.",
  "settings.languageTitle": "Język",
  "settings.langNotBooked": "Wyszarzone języki nie zostały jeszcze zamówione przez Twoją firmę. Porozmawiaj z szefem, jeśli chcesz z któregoś korzystać.",
  "tasks.quickLookup": "Szybkie wyszukiwanie",
  "tasks.doneHeading": "Już ukończone",
  "tasks.dueLabel": "Termin",
  "tasks.doneAtLabel": "Ukończono",
  "tasks.logoutAria": "Wyloguj",

  // Aufgabendetail (/monteur/aufgabe/:id)
  "aufgabe.notFound": "Nie znaleziono zadania.",
  "aufgabe.wrongOne": "Jedna odpowiedź była nieprawidłowa. Odpowiedz ponownie.",
  "aufgabe.wrongMany":
    "Nieprawidłowe odpowiedzi: {count}. Odpowiedz ponownie.",
  "aufgabe.saveFailed": "Zapisywanie nie powiodło się. Spróbuj ponownie.",
  "aufgabe.doneTitle": "Gotowe!",
  "aufgabe.doneBody":
    "Instruktaż „{title}” został ukończony. Twoje potwierdzenie zostało utworzone automatycznie i znajduje się w segregatorze kontrolnym Twojego zakładu.",
  "aufgabe.backToTasks": "Powrót do moich zadań",
  "aufgabe.stepContent": "Treść",
  "aufgabe.stepQuestion": "Pytanie {current} z {total}",
  "aufgabe.backShort": "Zadania",
  "aufgabe.readCalm": "Przeczytaj spokojnie do końca.",
  "aufgabe.questionsFollow": "Następnie pojawią się krótkie pytania sprawdzające ({count}).",
  "aufgabe.questionLabel": "Pytanie sprawdzające {current} / {total}",
  "aufgabe.wrongAgain":
    "Ta odpowiedź była nieprawidłowa w ostatniej próbie. Wybierz ponownie.",
  "aufgabe.prev": "Wstecz",
  "aufgabe.saving": "Zapisywanie…",
  "aufgabe.finish": "Zakończ instruktaż",
  "aufgabe.toQuestions": "Przejdź do pytań",
  "aufgabe.next": "Dalej",

  // Nachschlage-Suche (Komponente MonteurWeltSuche)
  "suche.placeholder": "Wyszukaj – np. „akumulator”, „okulary”, „drabina”…",
  "suche.inputAria": "Szukaj świata dokumentacji",
  "suche.matchIn": "Trafienie w {label}:",
  "suche.empty": "Nie znaleziono pasującego świata dokumentacji.",
  "suche.emptyHint": "Spróbuj innego słowa, np. „ŚOI” lub „opatrunek”.",

  // Welt-Nachschlagewerk (/monteur/welt/:id) – NUR UI-Rahmen/Labels.
  // Die eigentlichen Weltinhalte bleiben Daten (Backend-Resolver).
  "welt.headerTitle": "Wyszukiwanie",
  "welt.backAria": "Wstecz",
  "welt.errorNotAvailable": "Ten świat dokumentacji jest obecnie niedostępny.",
  "welt.errorLoad": "Nie udało się załadować świata.",
  "welt.backToTasks": "Powrót do moich zadań",
  "welt.loading": "Ładowanie świata…",
  "welt.doctype": "Materiał informacyjny",
  "welt.versionLabel": "Wersja",
  "welt.gbuTitle": "Ocena ryzyka zawodowego",
  "welt.noHazards": "Nie udokumentowano pojedynczych zagrożeń.",
  "welt.residualRisk": "Ryzyko resztkowe:",
  "welt.measureTechnical": "Techniczne",
  "welt.measureOrganizational": "Organizacyjne",
  "welt.measurePersonal": "Indywidualne",
  "welt.responsible": "Odpowiedzialny:",
  "welt.baTitle": "Instrukcja stanowiskowa",
  "welt.baSubtitle": "Zgodnie z TRBS / GefStoffV / BetrSichV",
  "welt.mainHazards": "Główne zagrożenia",
  "welt.protectiveMeasures": "Środki ochronne i zasady postępowania",
  "welt.emergency": "W sytuacji awaryjnej",
  "welt.firstAid": "Pierwsza pomoc",
  "welt.disposalHazmat": "Przechowywanie i utylizacja",
  "welt.disposalVehicle": "Odstawianie",
  "welt.disposalDefault": "Wyłączenie z eksploatacji",
  "welt.instructionTitle": "Instruktaż",
  "welt.instructionSubtitle": "Zgodnie z DGUV V1 §4",
  "welt.visualTitle": "Wizualne pomoce do nauki",
  "welt.visualSubtitle":
    "Ułatwiają zrozumienie – nie zmieniają treści, dowodów ani plików PDF",
  "welt.questionsTitle": "Pytania sprawdzające",
  "welt.questionsSubtitle":
    "Liczba pytań: {count} — autotest, bez zaznaczania prawidłowej odpowiedzi",
  "welt.maintenanceTitle": "Wskazówki dotyczące przeglądów i konserwacji",
  "welt.maintenanceSubtitle": "Zgodnie z BetrSichV / UVV",
  "welt.performedBy": "Wykonanie:",
  "welt.recommendedCheck": "Zalecane badanie przez rzeczoznawcę:",
  "welt.recurrenceTitle": "Cykle przypomnień",
  "welt.recurrenceSubtitle": "Dla każdego elementu – automatycznie monitorowane przez system",
  "welt.recurrenceUnterweisung": "Instruktaż",
  "welt.recurrenceGbuReview": "Ocena ryzyka – przegląd",
  "welt.recurrenceWartung": "Konserwacja / przegląd",
  "welt.recurrence.none": "–",
  "welt.recurrence.einmalig": "Jednorazowo",
  "welt.recurrence.monatlich": "Co miesiąc",
  "welt.recurrence.vierteljaehrlich": "Co kwartał",
  "welt.recurrence.halbjaehrlich": "Co pół roku",
  "welt.recurrence.jaehrlich": "Co rok",
  "welt.recurrence.zwei_jahre": "Co 2 lata",

  // Aufgaben-Status (StatusBadge) – Phase 7E P0.2.
  "status.offen": "Otwarte",
  "status.erledigt": "Ukończone",
  "status.ueberfaellig": "Zaległe",

  // CLARTEXT SPRACHE V1.1 (Demo-Feinschliff) – polnische Anzeige der 5 festen
  // Abschnitts-Überschriften. Schlüssel-IDENTISCH zu de.js. Reiner Anzeige-Layer.
  "contentHeading.Worum geht es?": "O co chodzi?",
  "contentHeading.Welche Gefahren bestehen?": "Jakie zagrożenia występują?",
  "contentHeading.Vor Arbeitsbeginn beachten": "Przed rozpoczęciem pracy",
  "contentHeading.Während der Arbeit beachten": "Podczas pracy",
  "contentHeading.Nach der Arbeit beachten": "Po zakończeniu pracy",

  // CLARTEXT SPRACHE AP-V1 – polnische UI-/Präsentationslabels der visuellen
  // Lernschicht. Schlüssel-IDENTISCH zu de.js. Reiner Anzeige-/Struktur-Layer;
  // fachliche Inhalte bleiben unberührt.
  "vlo.safetySymbols.title": "Symbole bezpieczeństwa",
  "vlo.safetySymbols.hint":
    "Te symbole wspierają instruktaż. Decydujący jest zawsze tekst.",
  "vlo.psaSummary.title": "Podsumowanie ŚOI",
  "vlo.hazardMarkers.title": "Oznaczenia zagrożeń",
  "vlo.learningFocus.title": "Fokus nauki",
  "vlo.richtigFalsch.title": "Prawidłowo i nieprawidłowo",
  "vlo.richtigFalsch.correct": "Prawidłowo",
  "vlo.richtigFalsch.wrong": "Nieprawidłowo",

  // PRINT.1 (Juni 2026) – etykiety plakatu (elementy UI drukowanego plakatu).
  "plakat.eyebrow": "Plakat instruktażowy",
  "plakat.subtitle": "Pracuj bezpiecznie – najważniejsze zasady w skrócie",
  "plakat.symbols": "Znaki bezpieczeństwa",
  "plakat.hazards": "Zagrożenia",
  "plakat.richtigFalsch": "Dobrze i źle",
  "plakat.correct": "Dobrze",
  "plakat.wrong": "Źle",
  "plakat.psa": "Środki ochrony indywidualnej (ŚOI)",
  "plakat.rules": "Najważniejsze zasady",
  "plakat.qrTitle": "Otwórz świat bezpośrednio",
  "plakat.qrText": "Zeskanuj kod QR telefonem, wpisz PIN – ten świat dokumentacji otworzy się natychmiast.",
  "plakat.footerHint": "Ten plakat wspiera instruktaż. Wiążący pozostaje pełny instruktaż.",
  "plakat.moreInFull": "Więcej treści w pełnym instruktażu",

  // AP-PLAKAT-UX (Juni 2026) – podtytuły grup + wielostronicowość.
  "plakat.hazardsSub": "Co może się stać?",
  "plakat.correctSub": "Jak pracować bezpiecznie.",
  "plakat.wrongSub": "Jak nie wolno pracować.",
  "plakat.continued": "ciąg dalszy",
  "plakat.page": "Strona",
};

const plExtra = {
  "aushang.linkTitle": "Ustawy i przepisy podlegające obowiązkowi wywieszenia",
  "aushang.linkSubtitle": "Urzędowe teksty oryginalne",
  "aushang.pageTitle": "Ustawy i przepisy podlegające obowiązkowi wywieszenia",
  "aushang.categoryAllgemein": "Ogólne podstawy prawne",
  "aushang.categoryDguv": "Przepisy DGUV i reguły techniczne",

  "common.back": "Wstecz",
  "common.notEnabled": "Ta funkcja nie jest aktywna dla Twojej firmy.",

  "aushang.kicker": "Obowiązek wywieszenia",
  "aushang.intro": "Odnośniki do urzędowych tekstów oryginalnych. Operator prowadzi listę centralnie; aktualizacje są sprawdzane przed publikacją.",
  "aushang.loadError": "Nie udało się załadować listy.",
  "aushang.listLoading": "Ładowanie…",
  "aushang.listEmpty": "Brak wpisów — operator prowadzi listę w konsoli operatora.",
  "aushang.categoryEmpty": "Brak wpisów w tej kategorii.",

  "hsp.kicker": "Plan ochrony rąk",
  "hsp.titleFallback": "Plan ochrony skóry i rąk",
  "hsp.loadError": "Nie udało się załadować planu ochrony rąk.",
  "hsp.empty": "Dla tego obszaru pracy nie ma obecnie planu ochrony rąk.",
  "hsp.plakatCreatingTitle": "Plakat jest tworzony",
  "hsp.plakatCreatingText": "Przy pierwszym otwarciu generowane są obrazy — może to potrwać do dwóch minut. Potem plakat będzie dostępny od razu.",
  "hsp.plakatFailedTitle": "Nie udało się utworzyć plakatu.",
  "hsp.plakatFailedHint": "Proszę spróbować ponownie. Widok tekstowy jest dostępny poniżej.",
  "hsp.plakatReload": "Nie udało się teraz załadować plakatu. Proszę odświeżyć stronę.",
  "hsp.plakatTimeout": "Tworzenie trwa dłużej niż oczekiwano. Proszę spróbować później.",
  "hsp.plakatRetry": "Nie udało się utworzyć plakatu. Proszę spróbować ponownie.",
  "hsp.plakatLoadFailed": "Nie udało się teraz załadować plakatu.",
  "hsp.plakatImgError": "Nie można wyświetlić obrazu plakatu.",
  "hsp.plakatAlt": "Plakat planu ochrony rąk",
  "hsp.plakatLoadingAria": "Trwa ładowanie plakatu",
  "hsp.textOpen": "Pokaż jako tekst",
  "hsp.textClose": "Zamknij widok tekstowy",
  "hsp.thWas": "Co",
  "hsp.thWann": "Kiedy",
  "hsp.thWomit": "Czym",
  "hsp.thWie": "Jak",
  "hsp.firstAidTitle": "Pierwsza pomoc po kontakcie ze skórą",
  "hsp.gsvOne": "1 substancja niebezpieczna w tym obszarze",
  "hsp.gsvMany": "Substancje niebezpieczne w tym obszarze: {count}",
  "hsp.gsvMenge": "Ilość w zakładzie:",
  "hsp.gsvHSaetze": "Zwroty H:",
  "hsp.psaHandschutz": "Ochrona rąk",
  "hsp.psaAtemschutz": "Ochrona dróg oddechowych",
  "hsp.psaAugenschutz": "Ochrona oczu",
  "hsp.psaKoerperschutz": "Ochrona ciała",
  "hsp.psaErsteHilfe": "Pierwsza pomoc po kontakcie ze skórą",
  "hsp.psaAetzReiz": "Działanie żrące/drażniące",
  "hsp.psaSensibilisierung": "Działanie uczulające",
  "hsp.psaPSaetze": "Zwroty P",

  "fuehrerschein.title": "Kontrola prawa jazdy",
  "fuehrerschein.loadError": "Nie udało się wczytać zadania.",
  "fuehrerschein.notApplicable": "Obecnie nie jest dla Ciebie przewidziana kontrola prawa jazdy.",
  "fuehrerschein.categoriesTitle": "Twoje rodzaje pojazdów",
  "fuehrerschein.categoriesSubtitle": "Te rodzaje pojazdów ustalił dla Ciebie pracodawca.",
  "fuehrerschein.categoriesEmpty": "Brak przypisanych kategorii.",
  "fuehrerschein.upToDateTitle": "Prawo jazdy aktualnie ważne",
  "fuehrerschein.upToDateText": "Obecnie nie ma zaplanowanej kontroli.",
  "fuehrerschein.nextDue": "Następna kontrola do dnia",
  "fuehrerschein.lastDecision": "Ostatnie zatwierdzenie:",
  "fuehrerschein.submittedTitle": "Przesłano pomyślnie",
  "fuehrerschein.submittedText": "Zdjęcie prawa jazdy i oświadczenie są teraz u pracodawcy do weryfikacji.",
  "fuehrerschein.submittedAt": "Przesłano dnia",
  "fuehrerschein.declarationTitle": "Oświadczenie",
  "fuehrerschein.declarationAccept": "Przeczytałem/-am oświadczenie i je potwierdzam.",
  "fuehrerschein.photoFrontTitle": "Zdjęcie prawa jazdy: przód",
  "fuehrerschein.photoFrontHint": "Proszę czytelnie sfotografować przód prawa jazdy (widoczne imię i nazwisko oraz data ważności).",
  "fuehrerschein.photoBackTitle": "Zdjęcie prawa jazdy: tył",
  "fuehrerschein.photoBackHint": "Proszę czytelnie sfotografować tył prawa jazdy (widoczna tabela kategorii).",
  "fuehrerschein.previewFrontAlt": "Podgląd: przód prawa jazdy",
  "fuehrerschein.previewBackAlt": "Podgląd: tył prawa jazdy",
  "fuehrerschein.otherPhoto": "Inne zdjęcie",
  "fuehrerschein.remove": "Usuń",
  "fuehrerschein.pickFront": "Zrób zdjęcie przodu lub wybierz plik",
  "fuehrerschein.pickBack": "Zrób zdjęcie tyłu lub wybierz plik",
  "fuehrerschein.pickLimits": "Maks. 12 MB · JPEG, PNG, WEBP, HEIC",
  "fuehrerschein.submit": "Prześlij",
  "fuehrerschein.submitting": "Przesyłanie…",
  "fuehrerschein.submitSuccess": "Przesłano pomyślnie.",
  "fuehrerschein.submitFailed": "Przesyłanie nie powiodło się. Proszę spróbować ponownie.",
  "fuehrerschein.errFormat": "Nieobsługiwany format obrazu. Proszę wybrać JPEG, PNG, WEBP, HEIC lub HEIF.",
  "fuehrerschein.errSize": "Plik jest za duży. Maksimum: 12 MB.",
  "fuehrerschein.ocrPreparing": "Przygotowywanie automatycznego odczytu…",
  "fuehrerschein.ocrUnavailable": "OCR chwilowo niedostępny — proszę sprawdzić prawo jazdy ręcznie.",
  "fuehrerschein.ocrBannerStrong": "Automatyczny odczyt",
  "fuehrerschein.ocrBannerRest": " — bez weryfikacji przez CLartext, nie zastępuje kontroli wzrokowej.",
  "fuehrerschein.ocrName": "Imię i nazwisko (odczytane)",
  "fuehrerschein.ocrExpiry": "Data ważności (odczytana)",
  "fuehrerschein.ocrClasses": "Kategorie (odczytane)",
};
Object.assign(pl, plExtra);

export default pl;
